let iframe = document.querySelector('iframe[src*="player.vimeo.com"]');

if (iframe) {
    let player = new Vimeo.Player(iframe);
    let isCurrentlyMuted = true;
    let soundSwitcherIconOn = document.querySelector('.show-icon-sound-on');
    let soundSwitcherIconOff = document.querySelector('.show-icon-sound-off');

    document.getElementById('switchermute').addEventListener('click', function(event) {
        if (isCurrentlyMuted) {
            soundSwitcherIconOn.style.display = 'block';
            soundSwitcherIconOff.style.display = 'none';

            player
                .setVolume(0.5)
                .then(function(volume) {
                    isCurrentlyMuted = false;
                })
                .catch(function(error) {
                    switch (error.name) {
                        case 'RangeError':
                            // The volume is less than 0 or greater than 1
                            break;

                        default:
                            // Some other error occurred
                            break;
                    }
                });
        } else {
            soundSwitcherIconOff.style.display = 'block';
            soundSwitcherIconOn.style.display = 'none';

            player
                .setVolume(0)
                .then(function(volume) {
                    isCurrentlyMuted = true;
                })
                .catch(function(error) {
                    switch (error.name) {
                        case 'RangeError':
                            // The volume is less than 0 or greater than 1
                            break;

                        default:
                            // Some other error occurred
                            break;
                    }
                });
        }
    });
}
